// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp } from "_core/slices/datas/TransactionSlice";

const AdminAccountEditApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/account_edit";

    // API実行, t_account_id, requestData(変更する項目のみを含める)
    const ExecAdminAccountEditApi = async (t_account_id, requestData) => {

        // 必要なリクエストを定義(未変更の項目は送信しない)
        const requestParams = {
            t_account_id: t_account_id,
            ...requestData,
        };

        let response = null;
        let error = null;

        try {
            response = await ApiRequest({ url:url, requestParams:requestParams });
        } catch (e) {
            error = e;
        }

        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
        }
        return { response, error };
    };

    return ExecAdminAccountEditApi;
};

export default AdminAccountEditApi;
